import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to the element matching the URL hash when the location changes.
 * Needed because React SPAs render asynchronously, so the browser's native
 * scroll-to-hash runs before the target element exists in the DOM.
 */
export function useScrollToHash(): void {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = hash.slice(1);
    if (!id) return;

    const scrollToElement = (): void => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    // Defer until after React has rendered the route's content and the browser has painted
    const frameId = requestAnimationFrame(() => {
      requestAnimationFrame(scrollToElement);
    });

    return () => cancelAnimationFrame(frameId);
  }, [hash]);
}
